import { render, staticRenderFns } from "./ThePersonPage.vue?vue&type=template&id=821d8140&scoped=true"
import script from "./ThePersonPage.vue?vue&type=script&lang=js"
export * from "./ThePersonPage.vue?vue&type=script&lang=js"
import style0 from "./ThePersonPage.vue?vue&type=style&index=0&id=821d8140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821d8140",
  null
  
)

export default component.exports